/**
 * Copyright © Veeam Software Group GmbH.
 */

export enum ConnectionStatuses {
    None = 'none',
    Success = 'success',
    Failed = 'failed',
    Closed = 'closed',
}
